import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { Breadcrumb, Button, OverlayTrigger, Table } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { BiChevronLeft, BiChevronRight, BiPencil } from "react-icons/bi";
import { BsFillEyeFill,BsChevronRight,BsChevronLeft } from "react-icons/bs";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from 'react-toastify';
import { EventContext, LoaderContext } from '../../../../App';
import { EventType, LS_AUTHORITY_KEY, LS_SELECTED_MAT_ISSUE_YEAR, MaterialityType, currentYear, startYear } from '../../../../core/constants/common';
import MaterialIssueService from '../../../../core/service/MaterialIssueService';
import Utils from '../../../../core/utilities/Utils';
import assessment_pic from "../../../../images/Assessment.png";
import ReportExportModal from '../../../SubscriberSupplierAdmin/Reporting/ReportExportModal';
import './MaterialityAssessment.scss';


const ScoreCardList = ({ t }) => {
	const [searchParams] = useSearchParams();
	const [reportToExport, setReportToExport] = useState({ id: 0 });
	const lsDat = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
	const companyId = lsDat.profile.company.id;
	const companyName = lsDat.profile.company.legalName;
	const selectedYear = localStorage.getItem(LS_SELECTED_MAT_ISSUE_YEAR) ?? null
	const period = searchParams.get('period') ?? '';
	const assYear = period ? period.substring(0, 4) : '';
	const { setLoaderDisplay } = useContext(LoaderContext);
	const [scores, setScores] = useState([]);
	const navigate = useNavigate();
	const assessmentId = searchParams.get('aId') ?? 0;
	
	const yearOptions = [];
	const year = new Date().getFullYear();
	for (let i = currentYear; i >= startYear; i--) {
		yearOptions.push(<option value={i} key={i}>{i}</option>);
	}
	const [filter, setFilter] = useState({
		year: selectedYear ?? `${year}`,
	});
	const { setEvent } = useContext(EventContext);

	useEffect(() => {
		localStorage.setItem(LS_SELECTED_MAT_ISSUE_YEAR, filter.year);

		if (assessmentId) {
			getScorecard();
		} else {
			getScorecardVersions();
		}
	}, [filter]);

	const getScorecard = () => {
		setLoaderDisplay(true);
		MaterialIssueService.getConsolidatedScoreCard(companyId, assessmentId).then(res => {
			setLoaderDisplay(false);
			if (res.status !== 200) return;

			setScores(res.data ?? []);
		}).catch(err => {
			setLoaderDisplay(false);
		});
	};

	const getScorecardVersions = () => {
		setLoaderDisplay(true);
		MaterialIssueService.getSCVersions(companyId, filter.year).then(res => {
			setLoaderDisplay(false);
			if (res.status !== 200) return;
			res.data.sort((a, b) => b.versionId - a.versionId);
			setScores(res.data ?? []);
		}).catch(err => {
			setLoaderDisplay(false);
		});
	};

	const generateReport = (version) => {
		setLoaderDisplay(true);
		MaterialIssueService.genReport(companyId, version, companyName).then(res => {
			setLoaderDisplay(false);
			if (res.status !== 200) return;
			toast.success("Report generated successfully", {
				position: toast.POSITION.TOP_RIGHT,
			});
			getScorecardVersions();
		}).catch(err => {
			setLoaderDisplay(false);
		});
	};

	const gotoReport = (reportId) => {
		navigate(`/company_admin/dmat/report?reportId=` + reportId, { state: { assessmentId } });
	}

	const gotoDetails = (score, mode) => {
		navigate("../scorecard" + `?aId=${score.assessmentId}&version=${score.versionId}&status=${score.status}&mode=${mode}`, { state: score });
	}

	const renderHeader = () => {
		return (
			<>
				<div className="List_header pb-0">
					<Breadcrumb className='h5'>
						<Breadcrumb.Item onClick={() => navigate(`/company_admin/dmat/stats`)}>{t("Materiality.label")}</Breadcrumb.Item>
						<Breadcrumb.Item active>{t("ScoreCards.label")}</Breadcrumb.Item>
					</Breadcrumb>
					<div className="header-actions">
						{/* <button className="btn btn-headbtn" >
							<BsFilter />
						</button>
						<button className="btn btn-headbtn" >
							<BiDownload />
						</button> */}
						<select className="form-select  w-auto form-select-sm" value={filter.year} 
							onChange={(e) => { 
								setFilter({ ...filter, year: e.target.value }); 
								setEvent({
									event: EventType.DOUBLE_MAT_YEAR_CHANGED,
									data: { year: e.target.value},
								});
							}}>
							{yearOptions}
						</select>

						<OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("NavigateBackAndNext.MatAssessment"))}>
							<Button variant='secondary' className='back-btn btn-sm scorecard-btn' onClick={() => navigate(`/company_admin/dmat/matassessments`)}>
								<BsChevronLeft /> <span>{t("Back.label")}</span>
							</Button>
						</OverlayTrigger>
						<OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("NavigateBackAndNext.MatReport"))}>
							<Button variant='secondary' className='next-btn btn-sm scorecard-btn' onClick={() => navigate(`/company_admin/dmat/report/list`)}>
								<span>{t("Next.label")}</span> <BsChevronRight />
							</Button>
						</OverlayTrigger>
					</div>
				</div>
			</>
		);
	};

	const blankCardToRender = () => {
		return (
			<div className="Assessment_blankcard">
				<div>
					<div className="assessment_pic">
						<img src={assessment_pic} />
					</div>
					<h4 className="mb-4">{t('ScorecardBlankHeader.label')}</h4>
				</div>
			</div>
		);
	};

	const groupByAssessment = (data) => {
		const grouped = {};

		data.forEach((item) => {
			const parts = item.assessmentName.split('-').map(part => part.trim());
			const yearVersion = parts.find(part => part.match(/^\d{4}\sV\d+$/))?.replace(' V', ' - Version ');

			if (yearVersion) {
				if (!grouped[yearVersion]) {
					grouped[yearVersion] = [];
				}
				grouped[yearVersion].push(item);
			}
		});

		Object.values(grouped).forEach(group => {
			group.sort((a, b) => {
				if (a.status === 'DRAFT' && b.status === 'FINALIZED') return -1;
				if (a.status === 'FINALIZED' && b.status === 'DRAFT') return 1;
			});
		});
		return grouped;
	};

	const renderTableHeader = () => {
		return (
			<thead>
				<tr>
					<th>{t('SurveyYear.label')} / {t("Version.label")}</th>
					<th>{t('ScoreCardVersion.label')}</th>
					<th>{t('Type.label')}</th>
					<th className='text-center'>{t('Status.label')}</th>
					<th className='text-center'>{t('CreatedOn.label')}</th>
					<th className='text-center'></th>
				</tr>
			</thead>
		);
	};

	const renderRows = () => {
		return <>
			{
				Object.entries(groupByAssessment(scores)).map(([group, items], groupIndex) => (
					<React.Fragment key={`group-${groupIndex}`}>
						<tr className='ScoreCardYear'>
							<td colSpan="5"><strong>{group}</strong></td>
						</tr>
						{items.map((score, index) => (
							<tr key={`item-${groupIndex}-${index}`}>
								<td></td>
								<td>{`Version ${score.version.slice(1)}`}</td>
								<td>{`${score.materialityVersionType === MaterialityType.SINGLE ? 'Impact Materiality' : 'Double Materiality'}`}</td>
								<td className="text-center">
									{
										score.status == 'DRAFT' &&
										<span className="badge bg-badge-Inprogress rounded-pill py-1">{score.status !== null ? Utils.toTitleCase(score.status) : 'NA'}</span>
									}
									{
										score.status == 'FINALIZED' &&
										<span className="badge bg-badge-Finalized rounded-pill py-1">{score.status !== null ? Utils.toTitleCase(score.status) : 'NA'}</span>
									}
								</td>
								<td className="text-center">{moment(score?.createdDate).format("DD MMM YYYY, h:mm A")}</td>
								<td className="text-center">
									{
										score.status == 'FINALIZED' &&
										<OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("ViewScorecard.label"))}>
											<span className='cursor' onClick={() => gotoDetails(score, 'VIEW')}> <BsFillEyeFill /></span>
										</OverlayTrigger>
									}
									{
										score.status == 'DRAFT' &&
										<OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("Edit.label"))}>
											<span className='cursor' onClick={() => gotoDetails(score, 'EDIT')}> <BiPencil /></span>
										</OverlayTrigger>
									}
								</td>
							</tr>
						))}
					</React.Fragment>
				))
			}
		</>;
	};

	return (
		<div className='ScoreCardbox 1'>
			{renderHeader()}
			{scores.length === 0 && blankCardToRender()}
			{
				scores.length > 0 &&
				<div className='ScoreCardTable_003 mt-2'>
					<Table className='mb-0'>
						{renderTableHeader()}
						<tbody className='table-border-bottom-0'>
							{renderRows()}
						</tbody>
					</Table>
				</div>
			}
			{
				reportToExport?.id > 0 &&
				<ReportExportModal
					reportId={reportToExport?.id}
					exportAs={reportToExport?.exportAs}
					onHide={() => setReportToExport({ id: 0 })}
					activeView={'DOUBLE_MAT'}
				/>
			}
		</div>
	)
};

export default withTranslation()(ScoreCardList);